// Has the user changed anything? <Form> tracks values/touched/errors but not a dirty.
const sameList = (left, right) =>
  left.length === right.length && left.every((item, at) => item === right[at]);

export const isFormDirty = (values, initialValues) => {
  if (!values || !initialValues) return false;

  return Object.keys(initialValues).some((key) => {
    const current = values[key];
    const initial = initialValues[key];

    if (Array.isArray(initial) || Array.isArray(current)) {
      return !sameList(current ?? [], initial ?? []);
    }
    return (current ?? '') !== (initial ?? '');
  });
};

// Links removed but not saved; seeded into initialValues so isFormDirty sees a removal.
export const REMOVED_LINKS = 'removedLinks';

export const removedLinksOf = (values) => values?.[REMOVED_LINKS] ?? [];

export const withRemovedLink = (values, id) => [...removedLinksOf(values), id];
